import { gql } from '@apollo/client';

export const GET_ZOHO_SERVICES = gql`
    query GetZohoServices($workspaceId: ID, $serviceId: ID, $staffId: ID) {
        getZohoServices(workspace_id: $workspaceId, service_id: $serviceId, staff_id: $staffId) {
            id
            name
            duration
            service_type
            embed_url
        }
    }
`;

export const GET_ZOHO_STAFF = gql`
    query GetZohoStaff($serviceId: ID, $workspaceId: ID) {
        getZohoStaff(service_id: $serviceId, workspace_id: $workspaceId) {
            id
            name
            email
            designation
        }
    }
`;

export const GET_ZOHO_AVAILABILITY = gql`
    query GetZohoAvailability($input: FetchZohoAvailabilityInput!) {
        getZohoAvailability(input: $input) {
            response
            slots
            time_zone
        }
    }
`;

export const BOOK_ZOHO_APPOINTMENT = gql`
    mutation BookZohoAppointment($input: BookZohoAppointmentInput!, $jobApplicationId: ID) {
        bookZohoAppointment(input: $input, jobApplicationId: $jobApplicationId) {
            booking_id
            start_time
            end_time
            time_zone
            status
            service_name
            staff_name
            summary_url
        }
    }
`;

export const GET_ZOHO_BOOKING_BY_JOB_APPLICATION = gql`
    query GetZohoBookingByJobApplication($jobApplicationId: ID!) {
        getZohoBookingByJobApplication(jobApplicationId: $jobApplicationId) {
            _id
            zohoBookingId
            jobApplicationId
            serviceId
            staffId
            workspaceId
            status
            startTime
        }
    }
`;

export const RESCHEDULE_ZOHO_APPOINTMENT = gql`
    mutation RescheduleZohoAppointment($input: RescheduleZohoAppointmentInput!) {
        rescheduleZohoAppointment(input: $input) {
            booking_id
            start_time
            end_time
            time_zone
            status
            service_name
            staff_name
            summary_url
        }
    }
`;
